export const YT = {
  // Header
  logo: "yt-logo",
  searchInput: "yt-search-input",
  searchBtn: "yt-search-btn",
  navHome: "yt-nav-home",
  navChannel: "yt-nav-channel",
  // Home page
  homePage: "yt-home-page",
  videoGrid: "yt-video-grid",
  videoCard: "yt-video-card",
  sortSelect: "yt-sort-select",
  // Watch page
  watchPage: "yt-watch-page",
  player: "yt-player",
  rateStars: "yt-rate-stars",
  starBtn: "yt-star-btn",
  commentList: "yt-comment-list",
  commentForm: "yt-comment-form",
  commentAuthor: "yt-comment-author",
  commentText: "yt-comment-text",
  commentSubmit: "yt-comment-submit",
  // Channel page
  channelPage: "yt-channel-page",
  channelBanner: "yt-channel-banner",
  channelSubs: "yt-channel-subs",
  subscribeBtn: "yt-subscribe-btn",
  // Search page
  searchPage: "yt-search-page",
  searchResultCount: "yt-search-result-count",
};
